import { connect } from "react-redux";
import { ApplicationState } from "store";
import { actionCreators } from "page/calendar/store";
import {
    actionCreators as uiActionCreators,
    getActiveNavigationComponent,
} from "ui/store";
import CalendarCover from "./calendar-cover";
import { getFontOptions } from "burde-api-content/store";

const mapStateToProps = (state: ApplicationState) => ({
    activeComponent: getActiveNavigationComponent(state),
    fontOptions: getFontOptions(state),
});

const mapDispatchToProps = {
    ...actionCreators,
    ...uiActionCreators,
};

export default connect(mapStateToProps, mapDispatchToProps)(CalendarCover);
